import React, { useState } from 'react';
import styled from 'styled-components/macro';

import { sections } from '../../../common/config';
import { Section, Container } from '../styled';
import data from './data';
import Content from './Content';
import PreviewContent from './PreviewContent';

const Row = styled.div`
  display: flex;
`;

const FAQs = () => {
  const [index, setIndex] = useState(0);

  const incrementIndex = () => {
    setIndex(index === data.length - 1 ? 0 : index + 1);
  }

  return (
    <Section
      $height={sections.height.faqs}
      $align="end"
    >
      <Row>
        <Container $primary>
          <Content
            index={index}
            setIndex={setIndex}
          />
        </Container>

        <Container>
          <PreviewContent
            index={index === data.length - 1 ? 0 : index + 1}
            incrementIndex={incrementIndex}
          />
        </Container>
      </Row>
    </Section>
  );
}

export default FAQs;